import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SignaturObjectEditor.html?raw';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import { signatureObjectSigner, signatureObjectState } from "./signatureObjectTypes";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import pdfYousign from '../fileEditor/pdfYousign/pdfYousign';
import { yousignField } from "../fileViewer/pdfViewer/pdfTypes";
import filePreview from '../filePreview/filePreview';
import ClipboardTextBox from '../../moreCore/UI/ClipboardTextBox/ClipboardTextBox';

class SignaturObjectEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private flagReOrderSignersOnSave: boolean = true; //<- verhalten ob die pit order geandert werden soll kurz vor dem speichern
    private dlg: MdsLax<InstanceType<typeof GenericDialog>>;
    private flagLockSignTable: boolean = false;
    private state: signatureObjectState;
    private useAnchorCheck: MdsLax<InstanceType<typeof CheckBox>>;
    private sigBoxLabel: HTMLSpanElement;

    private signerWidgetContainer: HTMLDivElement;
    private displayTable: MdsLax<InstanceType<typeof StaticTable>>;
    private hintBoxRegestry: Record<number, MdsLax<InstanceType<typeof HintBox>>> = {};
    private linkCopyBox: Record<number, MdsLax<InstanceType<typeof ClipboardTextBox>>> = {};

    private addNewSignerBtn: HTMLButtonElement;

    private setSignatureFieldsBtn: HTMLButtonElement;

    private signatureFieldEditor: MdsLax<InstanceType<typeof pdfYousign>>;

    private signStatusLabel: HTMLSpanElement;
    private signStatusContainer: HTMLDivElement;

    private flagIsDirty: boolean = false;

    private setSigLangHintBox: MdsLax<InstanceType<typeof HintBox>>;

    private sigReqTimeLabel: HTMLSpanElement;

    private sigReqTimeContainer:HTMLDivElement;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useAnchorCheck.setType("togglebutton");
        this.useAnchorCheck.setValue(false, true);
        this.useAnchorCheck.setLabel(this.translate("SignatureObjectEditor__Label_DocAnchor"))
        this.useAnchorCheck.on("valueChange", lang.hitch(this, this._onChanged_UseAnchorCheck));

        this.setSigLangHintBox.setLabel(this.translate("SignatureObjectEditor__Label_Lang"));
        this.setSigLangHintBox.setCallfunction("Webtool_API_SignatureObject__Editor_languageHintBox");
        this.setSigLangHintBox.setLabelAttribute("description");
        this.setSigLangHintBox.on("valueChange", lang.hitch(this, this._onChanged_SigLangHintBox));

        window.addEventListener("beforeunload", lang.hitch(this, (ev:Event)=>{
            if (this.flagIsDirty == true){
                if (this._destroyed != true){
                    ev.preventDefault();
                    return '';
                }
            }
        }));

        //this.show("00000341:00000021");//RMTHIS - debug only "00000341:00000031"
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public show(pitId: string) {
        this.dlg = new GenericDialog();
        this.dlg.setCloseOnEnter(false);
        this.dlg.setCloseOnEscape(false);
        this.dlg.destroyOnClose = false;
        this.dlg.show(this, this.translate("SignatureObjectEditor__Header_Dlg"), null, null, 'saveclose', (btnId: number) => {
            if (btnId == 1) {
                if (this.flagIsDirty){
                    this._saveState();
                    this.emit("dirty", true);
                }
            }else{
                (this.destroyRecursive as any)(); //wenn nicht gespeichert wird, einfach widget destroyen
            }
        });
        this.dlg.addButton(
            "viewOriginalDoc",
            this.translate("SignatureObjectEditor__Btn_ViewOriginal"),
            lang.hitch(this, this._onClick_ViewOriginalDoc),
            null,
            null,
            "fas fa-file-alt",
            false,
            'left last',
            true

        );
        this.dlg.addButton(
            "viewSignedDoc",
            this.translate("SignatureObjectEditor__Btn_ViewSigned"),
            lang.hitch(this, this._onClick_ViewSigDoc),
            null,
            null,
            "fas fa-file-signature",
            false,
            'left last',
            true
        );
        this.dlg.addButton(
            "createSigUrl",
            this.translate("SignatureObjectEditor__ActionBtn_createSigUrl"),
            lang.hitch(this, this._onClick_CreateSignatureUrl),
            null,
            null,
            "fas fa-link",
            false,
            'left last',
            true
        );
        this.dlg.addButton(
            "cancel",
            this.translate("SignatureObjectEditor__ActionBtn_cancel"),
            lang.hitch(this, this._onClick_CancelSig),
            null,
            null,
            "fas fa-ban",
            false,
            'left last',
            true
        );
        this.dlg.addButton(
            "getStatus",
            this.translate("SignatureObjectEditor__ActionBtn_getStatus"),
            lang.hitch(this, this._onClick_GetStatus),
            null,
            null,
            "fas fa-sync-alt",
            false,
            'left last',
            true
        );
        this.StandbyStart();
        this.fetch_state_from_server(pitId);
    }

    private fetch_state_from_server(pitId: string) {
        this.flagIsDirty = false;
        this.RequestManager.callfunction(
            "Webtool_API_SignatureObject__Editor_fetchState",
            { objID: pitId },
            lang.hitch(this, this._onCallback_FetchState),
            lang.hitch(this, (err) => {
                this.StandbyStop();
                console.error(err.Message);
                this.showToast(err.Message, "fas fa-bug");
            })
        );
    }

    private _onCallback_FetchState(resp: signatureObjectState) {
        this.StandbyStop();
        for (let signer of resp.signers) {
            if (typeof signer.youSignSignatureField == 'string') {
                signer.youSignSignatureField = JSON.parse(signer.youSignSignatureField);
            }
        }
        this.state = resp;
        this.render_state();
    }

    private render_state() {
        if (this.state.signers.length > 0) {
            let isLocked = false;
            for (let signer of this.state.signers) {
                if (typeof signer.signatureLink == 'string') {
                    if (signer.signatureLink != "") {
                        isLocked = true;
                    }
                }
            }
            if (isLocked) {
                this.domNode.classList.add("lockSignTable");
                this.flagLockSignTable = true;
            } else {
                this.domNode.classList.remove("lockSignTable");
                this.flagLockSignTable = false;
            }
        }

        //dlg buttons
        if (this.state.signatureInfo.status.allowCancel) {
            this.dlg.enableButton("cancel");
        } else {
            this.dlg.disableButton("cancel");
        }
        if (this.state.signatureInfo.status.allowStatusRequest) {
            this.dlg.enableButton("getStatus");
        } else {
            this.dlg.disableButton("getStatus");
        }
        if (this.state.signatureInfo.status.allowRequestSigUrls) {
            this.dlg.enableButton("createSigUrl");
        } else {
            this.dlg.disableButton("createSigUrl");
        }

        if (this.flagIsDirty) {
            //alle buttons disablen
            this.dlg.disableButton("createSigUrl");
            this.dlg.disableButton("getStatus");
            this.dlg.disableButton("cancel");
        }


        // wir "frieren" die hoehe ein, damit beim neuaufbau evtl. die scrollbar nicht so stark spring
        let oldMinHeight = this.signerWidgetContainer.style.minHeight;
        this.signerWidgetContainer.style.minHeight = this.signerWidgetContainer.getBoundingClientRect().height + "px";
        //widgets destroyen
        for (let key in this.hintBoxRegestry) {
            this.hintBoxRegestry[key].destroyRecursive();
            delete this.hintBoxRegestry[key];
        }
        for (let key in this.linkCopyBox){
            this.linkCopyBox[key].destroyRecursive();
            delete this.linkCopyBox[key];
        }
        //static table cleanen
        if (typeof this.displayTable != 'undefined') {
            this.displayTable.destroyRecursive();
        }
        this.displayTable = new StaticTable();
        this.displayTable.placeAt(this.signerWidgetContainer);
        this.displayTable.setFormatter(lang.hitch(this, this._onFormat_DisplayTable));
        this.displayTable.setCyAttribute("SignaturObjectEditorDisplayTable");
        this.displayTable.addLayout({
            name: "signerList",
            label: "Standard",
            rows: [
                {
                    attributes: [
                        "signer",
                        "email",
                        "signLink"
                    ],
                    headings: [
                        this.translate("SignatureObjectEditor__Header_Table_Signer"),
                        this.translate("SignatureObjectEditor__Header_Table_EMail"),
                        this.translate("SignatureObjectEditor__Header_Table_SignatureURL")
                    ],
                    colspans: [
                        4,
                        2,
                        2
                    ],
                    widths: [
                        null,
                        null
                    ],
                    colNamesInternal: [
                        "signer",
                        "email",
                        "signLink"
                    ],
                    bgColors: [
                        "",
                        ""
                    ],
                    txtColors: [
                        "",
                        ""
                    ]
                }
            ]
        });
        if (this.flagLockSignTable == false) {
            this.displayTable.addCustomRowActionButton(
                "DELETE",
                lang.hitch(this, this._onDelete_Signer),
                'far fa-trash-alt',
                null,
            0,
                this.translate("SignatureObjectEditor__action_removeSigner"),
                true
            );
        }
        //neue entries einfuegen
        let fakeEntitys: Array<Object> = [];
        for (let signer of this.state.signers) {
            let row = {
                ID: signer.pitOrder,
                signer: signer.name,
                email: signer.email ?? "",
                signLink: signer.signatureLink ?? "",
                signerID: signer.signerID ?? "",
            };
            fakeEntitys.push(row);
        }
        this.displayTable.setData(fakeEntitys, "ID");

        //un-freeze hoehe
        this.signerWidgetContainer.style.minHeight = oldMinHeight;

        if (typeof this.state.originalFileID == 'string') {
            if (this.state.originalFileID != "") {
                this.dlg.enableButton("viewOriginalDoc");
            } else {
                this.dlg.disableButton("viewOriginalDoc");
            }
        } else {
            this.dlg.disableButton("viewOriginalDoc")
        }
        if (typeof this.state.signatureInfo.signedFileID == 'string') {
            if (this.state.signatureInfo.signedFileID != "") {
                this.dlg.enableButton("viewSignedDoc");
            } else {
                this.dlg.disableButton("viewSignedDoc");
            }
        } else {
            this.dlg.disableButton("viewSignedDoc");
        }

        let statusSet = false;
        if (typeof this.state.signatureInfo.status.code != 'undefined') {
            this.signStatusLabel.innerHTML = this.state.signatureInfo.status.description;
            this.signStatusLabel.title = this.state.signatureInfo.status.code;
            if (typeof this.state.signatureInfo.signatureRequestID == 'string'){
                if ((this.state.signatureInfo.signatureRequestID != "") && (this.state.signatureInfo.signatureRequestID != " ")){
                    this.sigReqTimeContainer.title = this.translate("SignatureObjectEditor__tooltip_signatureRequestID") + ": " + this.state.signatureInfo.signatureRequestID;
                }else{
                    this.sigReqTimeContainer.removeAttribute("title");
                }
            }else{
                this.sigReqTimeContainer.removeAttribute("title");
            }
            let pitColor = this.state.signatureInfo.status.pitColor ?? "";
            if (pitColor != "") {
                let txtColor = pitColor.split(":")[0];
                let bgColor = pitColor.split(":")[1];
                if (txtColor != "unset") {
                    txtColor = "#" + txtColor;
                }
                if (bgColor != "unset") {
                    bgColor = "#" + bgColor;
                }
                this.signStatusContainer.style.backgroundColor = bgColor;
                this.signStatusContainer.style.color = txtColor;
                this.signStatusContainer.classList.add("colorWasSet");
            } else {
                this.signStatusContainer.classList.remove("colorWasSet");
                this.signStatusContainer.style.backgroundColor = "unset";
                this.signStatusContainer.style.color = "unset";
            }

            statusSet = true;
        }

        if (statusSet == false) {
            this.signStatusLabel.innerHTML = "/";
            this.signStatusLabel.title = "/";
        }

        //lang hintbox
        if (this.flagLockSignTable == true) {
            this.setSigLangHintBox.setReadonly(true);
            this.setSigLangHintBox.enableSelectEntityDialog(false);
        } else {
            this.setSigLangHintBox.setReadonly(false);
            this.setSigLangHintBox.enableSelectEntityDialog(true);
        }
        this.setSigLangHintBox.setValue({
            ID: (this.state.signatureInfo.language.pitID ?? ""),
            description: (this.state.signatureInfo.language.displayName ?? "")
        },
            true);

        //sig request send at time label
        let time = this.state.signatureInfo.signatureSendAt ?? "";
        if (time != "") {
            let d = new Date(time);
            time = d.toLocaleString();
            this.sigReqTimeLabel.innerHTML = time;
        } else {
            this.sigReqTimeLabel.innerHTML = "/"
        }
        if (typeof this.state.signatureInfo.documentID == 'string'){
            if ((this.state.signatureInfo.documentID != "") && (this.state.signatureInfo.documentID != " ")){
                this.signStatusContainer.title = this.translate("SignatureObjectEditor__tooltip_documentID") + ": " + this.state.signatureInfo.documentID;
            }else{
                this.signStatusContainer.removeAttribute("title");
            }
        }else{
            this.signStatusContainer.removeAttribute("title");
        }

        //feld editiren btn
        if (this.state.documentContainsSignatureAnchors || this.flagLockSignTable) {
            this.setSignatureFieldsBtn.disabled = true;
            this.setSignatureFieldsBtn.classList.add("disabled");
        } else {
            this.setSignatureFieldsBtn.disabled = false;
            this.setSignatureFieldsBtn.classList.remove("disabled");
        }
        this.useAnchorCheck.setReadonly(this.flagLockSignTable);

        //use sigAnchors

        this.useAnchorCheck.setValue((this.state.documentContainsSignatureAnchors ?? false), true);

        //signatur btn + ueberschrift
        if (this.state.signers.length >= this.state.system_max_available_signers) {
            this.addNewSignerBtn.disabled = true;
        } else {
            this.addNewSignerBtn.disabled = false;
        }
        this.sigBoxLabel.innerHTML = this.translate("SignatureObjectEditor__Header_Signer") + " (" + this.state.signers.length + "/" + this.state.system_max_available_signers + ")";

        if (this.flagIsDirty) {
            this.dlg._setHeaderAttr(this.translate("SignatureObjectEditor__Header_Dlg") + "*");
            this.dlg.enableButton("save");
        } else {
            this.dlg._setHeaderAttr(this.translate("SignatureObjectEditor__Header_Dlg"));
            this.dlg.disableButton("save");
        }
    }

    private _onFormat_DisplayTable(cell: StaticTable.StaticTableCell<any>): boolean {
        let signer: signatureObjectSigner;
        for (let s of this.state.signers) {
            if (s.pitOrder == cell.entity["ID"]) {
                signer = s;
            }
        }
        switch (cell.name) {
            case 'signer':
                let container = document.createElement('div');
                container.setAttribute("pitOrder", cell.entity["ID"]); //ID = pitOrder
                if ((cell.entity["signerID"] != "") && (cell.entity["signerID"] != " ")){
                    container.title = this.translate("SignatureObjectEditor__tooltip_signerID") + ": " + cell.entity["signerID"];
                }
                cell.contentnode.appendChild(container);
                //hintbox widget
                this.hintBoxRegestry[signer.pitOrder] = new HintBox();
                this.hintBoxRegestry[signer.pitOrder].placeAt(container);
                if (this.flagLockSignTable) {
                    //read only
                    this.hintBoxRegestry[signer.pitOrder].setReadonly(true);
                } else {
                    //nur wenn nicht-read-only
                    this.hintBoxRegestry[signer.pitOrder].setCallfunction("Webtool_API_SignatureObject__Editor_signerHintBox");
                    this.hintBoxRegestry[signer.pitOrder].enableSelectEntityDialog(true);
                }
                this.hintBoxRegestry[signer.pitOrder].setLabelAttribute("gDisp_Firstname_Name");
                this.hintBoxRegestry[signer.pitOrder].on("valueChange", lang.hitch(this, this._onChanged_Hintbox, cell.entity["ID"]));
                this.hintBoxRegestry[signer.pitOrder].setValue({ ID: signer.pitID, gDisp_Firstname_Name: signer.name }, true);
                return true;
                break;
            case 'email':
                if (typeof cell.entity["email"] == 'string'){
                    if ((cell.entity["email"] == "") || (cell.entity["email"] == " ")){
                        cell.value = "";
                        return true;
                    }
                }
                break; //display only
            case 'signLink':
                if (typeof cell.entity["signLink"] == 'string'){
                    if ((cell.entity["signLink"] != "") && (cell.entity["signLink"] != " ")){
                        let c = document.createElement('div');
                        c.setAttribute("pitOrder", cell.entity["ID"]);
                        cell.contentnode.appendChild(c);
                        this.linkCopyBox[signer.pitOrder] = new ClipboardTextBox();
                        this.linkCopyBox[signer.pitOrder].placeAt(c);
                        this.linkCopyBox[signer.pitOrder].setLabelVisibility(false);
                        this.linkCopyBox[signer.pitOrder].setValue(cell.entity["signLink"]);
                        //this.linkCopyBox[signer.pitOrder].on("textCopied",lang.hitch(this, ()=>{}))
                        return true;
                    }else{
                        cell.value = "";
                        return true;
                    }
                }
                break;
        }
        return false;
    }

    private _onChanged_Hintbox(pitOrder: number) {
        let newValEntity = this.hintBoxRegestry[pitOrder].getValue("entity");
        let newName: string = newValEntity["gDisp_Firstname_Name"] ?? "";
        let newID: string = newValEntity["ID"] ?? "";
        let telecomEntity: any = newValEntity["ref_vw_telecom_addresses"] ?? {};
        let newEmail: string = telecomEntity["emailaddress"] ?? "";
        for (let s of this.state.signers) {
            if (s.pitOrder == pitOrder) {
                if (s.pitID != newID) {
                    this.flagIsDirty = true;
                }
                s.name = newName;
                s.pitID = newID;
                s.email = newEmail;
                this.render_state();
                return;
            }
        }
    }

    private _onDelete_Signer(rowObj: any) {
        this.flagIsDirty = true;
        let pitOrder: number = rowObj["entity"]["ID"];
        this.state.signers = this.state.signers.filter(s => s.pitOrder !== pitOrder);
        this.render_state();
    }

    private _onClick_AddNewSignerBtn(ev: Event) {
        let newPitOrder = 0;

        let counter = this.state.system_max_available_signers;
        while (counter != 0) {
            let exists = false;
            for (let s of this.state.signers) {
                if (s.pitOrder == counter) {
                    exists = true;
                }
            }
            if (exists == false) {
                newPitOrder = counter;
            }
            counter--;
        }
        if (newPitOrder == 0) {
            console.error("invalid order", this.state.signers);
            throw "unable to determine position";
        }

        this.state.signers.push({
            name: "",
            pitID: "",
            pitOrder: newPitOrder
        });
        this.state.signers.sort((a, b) => { return a.pitOrder - b.pitOrder });
        this.flagIsDirty = true;
        this.render_state();
    }

    private file_preview: MdsLax<InstanceType<typeof filePreview>>;

    private _onClick_ViewOriginalDoc(ev: Event) {
        if (typeof this.file_preview != 'undefined') {
            try {
                this.file_preview.destroyRecursive();
            } catch { }
        }
        this.file_preview = new filePreview();
        this.dlg.disableButton("viewOriginalDoc");
        this.StandbyStart(this.domNode);
        this.file_preview.show(
            { key: this.state.originalFileID },
            true,
            true,
            () => {
                this.dlg.enableButton("viewOriginalDoc");
                this.StandbyStop();
            },
            () => {
                this.dlg.enableButton("viewOriginalDoc");
                this.StandbyStop();
            }
        );
    }

    private _onClick_CreateSignatureUrl() {
        this.triggerObjectAction('createSigLink');
    }

    private _onClick_CancelSig() {
        this.triggerObjectAction('cancelSig');
    }

    private _onClick_GetStatus() {
        this.triggerObjectAction('retrieveStatus');
    }

    private triggerObjectAction(action: 'createSigLink' | 'cancelSig' | 'retrieveStatus') {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_SignatureObject__Editor_objectAction",
            { pitID: this.state.pitID, actionType: action },
            lang.hitch(this, this._responseCallback_ObjectAction),
            lang.hitch(this, (err) => {
                this.StandbyStop();
                console.error(err.Message);
                this.showToast(err.Message, "fas fa-bug");
            })
        );
    }

    private _responseCallback_ObjectAction(resp: any) {
        this.StandbyStop();
        this.fetch_state_from_server(this.state.pitID);
    }

    private _onClick_ViewSigDoc(ev: Event) {
        if (typeof this.file_preview != 'undefined') {
            try {
                this.file_preview.destroyRecursive();
            } catch { }
        }
        this.file_preview = new filePreview();
        this.dlg.disableButton("viewSignedDoc");
        this.StandbyStart(this.domNode);
        this.file_preview.show(
            { key: this.state.signatureInfo.signedFileID },
            true,
            true,
            () => {
                this.dlg.enableButton("viewSignedDoc");
                this.StandbyStop();
            },
            () => {
                this.dlg.enableButton("viewSignedDoc");
                this.StandbyStop();
            }
        );
    }

    private _onChanged_UseAnchorCheck() {
        this.flagIsDirty = true;
        let useDocAnchors = this.useAnchorCheck.getValue();
        this.state.documentContainsSignatureAnchors = useDocAnchors;
        this.render_state();
    }

    private _onChanged_SigLangHintBox(newVal: any) {
        this.state.signatureInfo.language["displayName"] = newVal.description ?? "";
        this.state.signatureInfo.language["pitID"] = newVal.ID ?? "";
        this.flagIsDirty = true;
        this.render_state();
    }

    private _onClick_SetSignatureBtn(ev: Event) {
        if (typeof this.signatureFieldEditor != 'undefined') {
            try {
                this.signatureFieldEditor.destroyRecursive();
            } catch { }
        }
        this.signatureFieldEditor = new pdfYousign();
        this.signatureFieldEditor.setDisableAutoSave(true); // wir handlen die speicher routine hier!
        let dat: Array<{ displayName: string, currentSignaturePlacement: string }> = [];
        for (let signer of this.state.signers) {
            let name = "";
            if (typeof signer.name != 'undefined') {
                name = signer.name;
            }
            let field = "";
            if (typeof signer.youSignSignatureField != 'undefined') {
                if (typeof signer.youSignSignatureField == 'object') {
                    field = JSON.stringify(signer.youSignSignatureField);
                }
                if (typeof signer.youSignSignatureField == 'string') {
                    field = signer.youSignSignatureField;
                }
            }
            dat.push({
                displayName: name,
                currentSignaturePlacement: field,
            });
        }
        this.signatureFieldEditor.show(this.state.pitID, true, {
            fileID: this.state.originalFileID,
            availableSigners: this.state.signers.length ?? 0,
            maxSigners: this.state.system_max_available_signers,
            signatureData: dat
        });
        //this.signatureFieldEditor.loadSignatureObject(this.state.pitID, true)
        this.signatureFieldEditor.on("firstRenderDone", lang.hitch(this, () => {
            //currently unused
        }));
        this.signatureFieldEditor.on("closed", lang.hitch(this, () => {
            this.flagIsDirty = true;
            let res: { objID: string, data: Array<{ signer_order: Number, yousignField: yousignField }> } = this.signatureFieldEditor.lastSaved;
            for (let elem of res.data) {
                for (let sig of this.state.signers) {
                    if (sig.pitOrder == elem.signer_order) {
                        sig.youSignSignatureField = elem.yousignField;
                    }
                }
            }
            this.render_state();
        }));
    }

    private async _saveState() {
        let payload: signatureObjectState = JSON.parse(JSON.stringify(this.state)); //deepcopy
        for (let signer of payload.signers){
            if (typeof signer.youSignSignatureField != 'string'){
                signer.youSignSignatureField = JSON.stringify(signer.youSignSignatureField) as any;
            }
        }

        //automatisches nachruecken von der order
        if (this.flagReOrderSignersOnSave){
            payload.signers = payload.signers.sort((a,b)=>{
                return a.pitOrder - b.pitOrder;;
            });
            let counter = 1;
            for (let signer of payload.signers){
                signer.pitOrder = counter;
                counter++;
            }
        }

        let res = await new Promise( (resolve)=>{
            this.RequestManager.callfunction(
                "Webtool_API_SignatureObject__Editor_saveState",
                payload,
                () => {
                    resolve(true);
                },
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-bug");
                    resolve(false);
                })
            );
        });

        if (res == true){
            (this.destroyRecursive as any)();
        }else{
            this.dlg.show(); //re-open on error
        }
    }
}

export default mdsWidget(SignaturObjectEditor);
